import { BackgroundImageProvider } from '../providers/backgroundImageProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_BACKGROUND_IMAGE = new AsyncAction('GET_BACKGROUND_IMAGE');

export function getBackgroundImageByLatLon(latitude, longitude, setId, baseUrl, authId, secret, stdParameters, verbose, refresh = false) {
	return {
		type: GET_BACKGROUND_IMAGE.base,
		payload: backgroundImageByLatLon(latitude, longitude, setId, baseUrl, authId, secret, stdParameters, verbose, refresh)
	};
}

async function backgroundImageByLatLon(latitude, longitude, setId, baseUrl, authId, secret, stdParameters, verbose, refresh) {
	const op = new BackgroundImageProvider(baseUrl, authId, secret);
	return await op.getBackgroundByLatLng(latitude, longitude, setId, stdParameters, verbose, refresh);
}
